import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import AES from "crypto-js/aes";
import { enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import { Alert } from "@mui/material";

const UpdateInWard = ({ navigation, handleCancel, trackingNo }) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(new Date());
  const [validationMessage, setValidationMessage] = useState("");

  const [fromName, setFromName] = useState("");
  const [transportOrCourier, setTransportOrCourier] = useState("");
  const [materialDescription, setMaterialDescription] = useState("");
  const [receivedBy, setReceivededBy] = useState("");
  const [checkedBy, setCheckedBy] = useState("");
  const [placeLocation, setPlaceLocation] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");

  useEffect(() => {
    // Fetch outward data by tracking number
    if (trackingNo) {
      setLoading(true);
      fetch(`${BASE_URL}/getInwardByTrackingNo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          trackingNo: trackingNo,
          uniqueId: decryptedUniqueId,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("data to be updated : ", data);
          if (data.message === "Inward entry found" && data.data) {
            setLoading(false);
            const outwardData = data.data;
            setFromName(outwardData.fromName || "");
            setTransportOrCourier(outwardData.transportOrCourier || "");
            setMaterialDescription(outwardData.materialDescription || "");
            setReceivededBy(outwardData.receivedBy || "");
            setCheckedBy(outwardData.checkedBy || "");
            setPlaceLocation(outwardData.placeLocation || "");
            setInvoiceNumber(outwardData.invoiceNumber || "");

            // Set date and time for DatePicker components
            if (outwardData.date) {
              setSelectedDate(new Date(outwardData.date));
            }
            if (outwardData.time) {
              const [hours, minutes, seconds] = outwardData.time.split(":");
              const timeDate = new Date();
              timeDate.setHours(parseInt(hours, 10));
              timeDate.setMinutes(parseInt(minutes, 10));
              timeDate.setSeconds(parseInt(seconds, 10));
              setSelectedTime(timeDate);
            }
          } else {
            setLoading(false);
            console.error("Error fetching Inward data");
            swal({
              icon: "error",
              title: "Failed to fetch Inward details",
            });
          }
          // setLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(false);
          swal({
            icon: "error",
            title: "An Error Occurred While Fetching Inward Details",
          });
        });
    } else {
      setLoading(false);
    }
  }, [trackingNo]);

  const validateForm = () => {
    let newValidationMessage = "";

    if (!fromName) {
      newValidationMessage += "Please enter the sender's name.\n";
    } else if (!transportOrCourier) {
      newValidationMessage +=
        "Please enter the transport or courier details.\n";
    } else if (!materialDescription) {
      newValidationMessage += "Please enter the material description.\n";
    } else if (!receivedBy) {
      newValidationMessage +=
        "Please enter the name of the person receiving the item.\n";
    } else if (!checkedBy) {
      newValidationMessage +=
        "Please enter the name of the person checking the item.\n";
    } else if (!placeLocation) {
      newValidationMessage += "Please enter the place or location.\n";
    } else if (!invoiceNumber) {
      newValidationMessage += "Please enter the invoice or document number.\n";
    } else if (!selectedDate) {
      newValidationMessage += "Please select a date.\n";
    } else if (!selectedTime) {
      newValidationMessage += "Please select a time.\n";
    }

    setValidationMessage(newValidationMessage);
    return newValidationMessage === ""; // Return true if no validation messages
  };

  const handleUpdateInward = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      window.scrollTo(0, 0); // Scroll to top if validation fails
      return; // Stop submission if validation fails
    }

    const formData = new FormData();
    const inwardData = {
      fromName: fromName,
      transportOrCourier: transportOrCourier,
      materialDescription: materialDescription,
      checkedBy: checkedBy,
      receivedBy: receivedBy,
      placeLocation: placeLocation,
      date: selectedDate.toISOString().split("T")[0],
      time: selectedTime.toTimeString().split(" ")[0],
      trackingNo: trackingNo,
      invoiceNumber: invoiceNumber,
      uniqueId: decryptedUniqueId,
    };

    formData.append("request", JSON.stringify(inwardData));

    setLoading(true);

    fetch(`${BASE_URL}/updateInward`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Update Inward Response:", data);
        // handleCancel();
        if (data.message === "Inward entry updated successfully") {
          setLoading(false);
          swal({
            icon: "success",
            title: "Inward Updated Successfully",
          }).then(() => {
            handleCancel();
          });
        } else {
          setLoading(false);
          swal({
            icon: "error",
            title: "Failed to Update Inward",
            text: data.message || "An error occurred",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
        swal({
          icon: "error",
          title: "An Error Occurred While Updating Inward",
        });
      });
  };

  const handleCancleClick = () => {
    const confirmCancel = window.confirm(
      "Are you sure you want to leave this page?"
    );
    if (confirmCancel) {
      handleCancel();
    } else {
      console.log("Cancellation not confirmed");
    }
  };

  if (loading) {
    return (
      <div className="container-fluid ">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="container-fluid">
      <div className="my-3">
        <div className="d-flex align-items-center ml-1 mt-4">
          <div
            className="cursor-pointer d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              height: "35px",
              width: "38px",
            }}
          >
            <ArrowBackIosIcon
              width={2}
              onClick={handleCancleClick}
              className="arrow-child"
            />
          </div>
          <div className="newcustomer-head ml-2">
            <h5
              className="ml-1 mb-0"
              style={{ letterSpacing: "1px", color: "#086bd5de" }}
            >
              Update InWard
            </h5>
          </div>
        </div>
      </div>
      <Container fluid>
        <Card className="card-style p-4">
          {validationMessage && (
            <Alert severity="error" className="mt-0">
              {validationMessage.split("\n").map((message, index) => (
                <div key={index}>{message}</div>
              ))}
            </Alert>
          )}{" "}
          <Row>
            <Col md="3">
              <Form.Group>
                <label className="text-primary" style={{ fontWeight: "600" }}>
                  INWARD DETAILS
                </label>
              </Form.Group>
            </Col>
          </Row>
          <Form>
            <Row>
              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>From Name</label>
                  <Form.Control
                    name="fromName"
                    placeholder="Enter Name"
                    value={fromName}
                    onChange={(e) => setFromName(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Transport or Courier</label>
                  <Form.Control
                    name="transportOrCourier"
                    placeholder="Enter Transport/Courier"
                    value={transportOrCourier}
                    onChange={(e) => setTransportOrCourier(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Tracking Number</label>
                  <Form.Control
                    name="trackingNo"
                    placeholder="Enter Tracking Number"
                    value={trackingNo}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Material Description</label>
                  <Form.Control
                    name="materialDescription"
                    placeholder="Enter Material Description"
                    value={materialDescription}
                    onChange={(e) => setMaterialDescription(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Received by</label>
                  <Form.Control
                    name="receivedBy"
                    placeholder="Enter Packer's Name"
                    value={receivedBy}
                    onChange={(e) => setReceivededBy(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Checked by</label>
                  <Form.Control
                    name="checkedBy"
                    placeholder="Enter Checker's Name"
                    value={checkedBy}
                    onChange={(e) => setCheckedBy(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>Place / Location</label>
                  <Form.Control
                    name="placeLocation"
                    placeholder="Enter Location"
                    value={placeLocation}
                    onChange={(e) => setPlaceLocation(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              <Col md="3">
                <Form.Group className="d-flex flex-column new-campaign-time w-100">
                  <label style={{ color: "grey" }}>Date</label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select date"
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group className="d-flex flex-column new-campaign-time w-100">
                  <label style={{ color: "grey" }}>Time</label>
                  <DatePicker
                    selected={selectedTime}
                    onChange={(time) => setSelectedTime(time)}
                    className="form-control"
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={1}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select time"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              {/* Place / Location */}
              <Col md="3">
                <Form.Group>
                  <label style={{ color: "grey" }}>
                    Invoice / Document Number
                  </label>
                  <Form.Control
                    name="invoiceNumber"
                    placeholder="Enter Invoice / Document Number"
                    value={invoiceNumber}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr className="mt-4" />

            <div className="text-right invoice-bottombtns">
              <button className="btn-1 btn mt-0" onClick={handleCancleClick}>
                Cancel
              </button>
              <button
                className="btn-3 btn btn-primary"
                onClick={handleUpdateInward}
              >
                Update InWard
              </button>
            </div>
          </Form>
        </Card>
      </Container>
    </div>
  );
};

export default UpdateInWard;
